import React, { Component } from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"
import { Alert, Button } from "react-bootstrap"
import { DckSelectors, DckActionCreators } from "dck-redux"

import * as ItemTypes from "../../redux/items/types"
import { Link } from "react-router"
import LoanTable from "./LoanTable"
import { changeLoanStatus } from "../../redux/actions/loans"
import {
  DEFAULT_NAV_PAGE,
  DEFAULT_NAV_SIZE,
  fillingZeroUtility,
  getDefaultPagedResult,
  getGroupFromQueryString,
  getPlural,
  getStatusesByUserRole,
  GROUP_LIST,
  LoanCollateral,
  scrollToTop,
  statusColorStyle
} from "../../lib/utils"
import FontAwesome from "react-fontawesome"
import { blockingFetchService } from "../../lib/blockingFetch"
import apiServerApi from "../../redux/sagas/apiServerApi"
import Authenticated from "../../lib/Authenticated"
import UIAvatar from "../fragments/UIAvatar"
import PropTypes from 'prop-types'
import {
  buildLoanQueryString,
  checkAndRoute,
  getLoanFiltersFromBootstrapTable,
  getLoanSortKeyFromBootstrapTable,
  handleFilterChange,
  handleResetSorting,
  handleSortChange,
  LoanFilterParamNames
} from "../../lib/queryStringBuilder"

class ListLoans extends Component {

  static contextTypes = {
    router: PropTypes.object
  }

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  state = {
    openDeviceRunning: [],
    openDeviceError: null,
    showOpenDevice: true,
    showStatuses: false,
  }

  constructor(props) {
    super(props)

    this.clientNameRef = null 
    this.setClientNameRef = elt => {
      this.clientNameRef = elt
    }

    this.affiliatedRef = null 
    this.setAffiliatedRef = elt => {
      this.affiliatedRef = elt
    }

    this.bundleNameRef = null 
    this.setBundleNameRef = elt => {
      this.bundleNameRef = elt
    }

    this.collateralNameRef = null 
    this.setCollateralNameRef = elt => {
      this.collateralNameRef = elt
    }

    this.imeisListRef = null 
    this.setImeisListRef = elt => {
      this.imeisListRef = elt
    }
    
    this.createdByNameRef = null 
    this.setCreatedByNameRef = elt => {
      this.createdByNameRef = elt
    }

    this.assignToNameRef = null 
    this.setAssignToNameRef = elt => {
      this.assignToNameRef = elt
    }

    this.statusRef = null 
    this.setStatusRef = elt => {
      this.statusRef = elt
    }

    this.disburseDateFormattedRef = null 
    this.setDisburseDateFormattedRef = elt => {
      this.disburseDateFormattedRef = elt
    }
  }

  componentDidMount() {
    this.readQueryString()
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      this.readQueryString()
    }
  }

  readQueryString = () => {
    const filteringOptions = buildLoanQueryString(this.props.location)
    this.props.loadLoans(filteringOptions)
  }

  handleGroupChanged = group => {
    checkAndRoute('group', group, group !== GROUP_LIST.ALL, true, 
      this.context, this.props.location)
  }

  onPageChange = currentPage => {
    checkAndRoute('page', currentPage, currentPage !== DEFAULT_NAV_PAGE, false,
      this.context, this.props.location)
    scrollToTop()
  }

  onSizePerPageList = sizePerPage => {
    checkAndRoute('size', sizePerPage, sizePerPage !== DEFAULT_NAV_SIZE, true,
      this.context, this.props.location)
    scrollToTop()
  }

  onFilterChange = filterObj => {

    handleFilterChange(
      getLoanFiltersFromBootstrapTable(filterObj),
      LoanFilterParamNames,
      this.context,
      this.props.location
    )
  }

  onSortChange = (sortName, sortOrder) => {

    handleSortChange(
      getLoanSortKeyFromBootstrapTable(sortName),
      sortOrder,
      this.context,
      this.props.location
    )
  }

  doResetSorting = () => {
    handleResetSorting(
      this.context,
      this.props.location
    )
  }

  selectedHandler = id => this.props.setSelectedLoans(id)

  changeStatus = (id, status) => this.props.setLoanStatus(id, status)

  canOpenDevice = (loanId, devicesToOpen) => 
    devicesToOpen && devicesToOpen.findIndex(obj => obj.id === loanId) !== -1

  openDevices = loanIds => {

    this.setState({
      openDeviceError: null,
      showStatuses: true,
    })

    const successes = [],
    loanLength = loanIds.length

    for(let i in loanIds) {

      const loanId = loanIds[i].id,
      { openDeviceRunning } = this.state
      openDeviceRunning.push(loanId)
      this.setState({ openDeviceRunning })

      blockingFetchService(
        accessToken => apiServerApi.openDevice(accessToken, loanId),
        _ => {
          successes.push(loanId)
          if(successes.length === loanLength) {
            this.readQueryString()
          }
        },
        error => this.setState({ openDeviceError: error.text }),
        _ => {
          let { openDeviceRunning } = this.state
          openDeviceRunning = openDeviceRunning.filter(value => value !== loanId)
          this.setState({ openDeviceRunning })
        }
      )
    }
  }

  closeOpenDevice = () => this.setState({ showOpenDevice: false })

  closeShowStatuses = () => this.setState({ showStatuses: false })

  isOpenDeviceRunning = loanId => this.state.openDeviceRunning.findIndex(item => item === loanId) !== -1

  atLeastOpenDeviceRunning = () => this.state.openDeviceRunning.length > 0

  doClearFilters = () => {

    if (this.clientNameRef) {
      this.clientNameRef.cleanFiltered()
    }

    if (this.affiliatedRef) {
      this.affiliatedRef.cleanFiltered()
    }

    if (this.bundleNameRef) {
      this.bundleNameRef.cleanFiltered()
    }

    if (this.collateralNameRef) {
      this.collateralNameRef.cleanFiltered()
    }

    if (this.imeisListRef) {
      this.imeisListRef.cleanFiltered()
    }

    if (this.createdByNameRef) {
      this.createdByNameRef.cleanFiltered()
    }

    if (this.assignToNameRef) {
      this.assignToNameRef.cleanFiltered()
    }

    if (this.statusRef) {
      this.statusRef.cleanFiltered()
    }

    if (this.disburseDateFormattedRef) {
      this.disburseDateFormattedRef.cleanFiltered()
    }
  }

  renderOpenDevice = devicesToOpen => {

    if(!devicesToOpen || !devicesToOpen.length || !this.state.showOpenDevice
      || this.atLeastOpenDeviceRunning()) return null

    const nbDevices = devicesToOpen.reduce((prev, loan) => prev + loan.bundleQty, 0),
      info = `There ${nbDevices > 1 ? 'are' : 'is'} ${
      fillingZeroUtility(nbDevices) } ${ getPlural('device', nbDevices) } to open.`

    return (
      <Alert bsStyle="success" onDismiss={ this.closeOpenDevice }>
        <span><FontAwesome name="info-circle"/> { info }</span> &nbsp;
        <strong className="text-underline cursor-pointer"
          title="Proceed"
          onClick={() => this.openDevices(devicesToOpen)}>
          Click to open all
        </strong>
      </Alert>
    )
  }

  renderStatuses = () => {

    const atLeastOne = this.atLeastOpenDeviceRunning(),
      bsStyle = atLeastOne ? 'info' : 'warning',
      { showStatuses, openDeviceError } = this.state

    if(!showStatuses || (!atLeastOne && !openDeviceError)) return null

    return <Alert bsStyle={ bsStyle } onDismiss={ this.closeShowStatuses }>
      { atLeastOne
      ? <span><FontAwesome name='clock-o'/> Running 'Open Devices' ..</span>
      : openDeviceError
        ? <span>An error occurred. { openDeviceError } &nbsp;</span>
        : null
      }
    </Alert>
  }

  renderBatchPaymentButton = () => {

    if (!this.isAdmin) return null
    return (
      <Button bsStyle="info"
        onClick={() => this.context.router.push({ pathname: '/loans/batch-repayment' })}>
        <FontAwesome name='cloud-upload' /> Batch Repayment
      </Button>
    )
  }

  renderAffiliationLink = ({ business: bs, customer, isDefaulted }) => {
    const business = bs ? bs : customer ? customer.business : null
    return business ?
      <Link to={`/businesses/${business.id}/detail`} title="View" className={ isDefaulted ? 'red': '' }>
        { business.name } - { business.businessId }
      </Link> : ''
  }

  renderClientNameRow = ({ id, clientName, isDefaulted }) => (
    <span title='Show loan details'>
      <UIAvatar name={ clientName } size={ 22 } /> &nbsp;
      <Link to={`/loans/${id}/detail`} className={ isDefaulted ? 'red': '' }>
        { clientName }
      </Link> 
    </span>
  )

  renderActionButtons = ({ id, bundleQty }, devicesToOpen) => {

    const title = `Click to open ${
      fillingZeroUtility(bundleQty) } ${ getPlural('device', bundleQty) }`

    return (
      <span className="flex-detail">

        <Link to={`/loans/${id}/detail`} title='Show details' className='p-5'>
          <FontAwesome name="eye" />
        </Link>

        { this.isOpenDeviceRunning(id)
        ? <span title="Running 'Open Device'..">..</span>
        : this.canOpenDevice(id, devicesToOpen)
          ? <span className="cursor-pointer green p-5"
              onClick={() => this.openDevices([{ id }])}>
              <FontAwesome name="unlock" title={ title } />
            </span>
          : null
        }
      </span>
    )
  }

  renderCommandButtons = () => {

    const groupName = getGroupFromQueryString(this.props.location.query.group)

    return (
      <div className="mb-15 flex-row-simple flex-wrap gap-10 justify-end items-center">

        <label className="font-500" title="Show all">
          <input type="radio" name="group" value={ GROUP_LIST.ALL }
            checked={ groupName === GROUP_LIST.ALL }
            onChange={e => this.handleGroupChanged(e.target.value)} /> All
        </label>

        <label className="font-500" title="Defaulted loans">
          <input type="radio" name="group" value={ GROUP_LIST.DEFAULTED }
            checked={ groupName === GROUP_LIST.DEFAULTED }
            onChange={e => this.handleGroupChanged(e.target.value)} /> Defaulted
        </label>

        <Button bsStyle="default" onClick={ this.doClearFilters } className="font-size-13"
          title="Clear all filters">
          CLEAR FILTERS
        </Button>

        <Button bsStyle="default" onClick={ this.doResetSorting } className="font-size-13"
          title="Clear sorting">
          RESET SORTING
        </Button>

        { this.renderBatchPaymentButton() }
      </div>
    )
  }

  render() {

    const { pagedLoans, devicesToOpen } = this.props,
    { content, currentPage, pageSize, totalElements } = pagedLoans

    return (
      <div>

        { this.renderStatuses() }

        { this.renderOpenDevice(devicesToOpen) }

        { this.renderCommandButtons() }

        <LoanTable
          items={ content }
          selectedHandler={ this.selectedHandler }
          changeStatusClick={ this.changeStatus }

          dataTotalSize={ totalElements }
          page={ Number(currentPage) + 1 }
          onPageChange={ this.onPageChange }
          sizePerPage={ Number(pageSize) }
          onSizePerPageList={ this.onSizePerPageList }
          onFilterChange={ this.onFilterChange }
          onSortChange={ this.onSortChange }
        >
          <TableHeaderColumn
            ref={ this.setClientNameRef }
            dataField="clientName"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            dataFormat={(_, row) => this.renderClientNameRow(row)}
            csvHeader="Client"
            width="200"
          >
            Client
          </TableHeaderColumn>

          <TableHeaderColumn
            ref={ this.setAffiliatedRef }
            dataField="affiliated"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            dataFormat={(_, row) => this.renderAffiliationLink(row)}
            csvHeader="Affiliation"
            width="200"
          >
            Affiliated
          </TableHeaderColumn>

          <TableHeaderColumn
            ref={ this.setBundleNameRef }
            dataField="bundleName"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            columnClassName={(_, { isDefaulted }) => isDefaulted ? 'red' : ''}
            columnTitle
            csvHeader="Bundle"
            width="200"
          >
            Bundle
          </TableHeaderColumn>

          <TableHeaderColumn
            ref={ this.setCollateralNameRef }
            dataField="collateralName"
            dataSort
            filter={{ type: "SelectFilter", options: LoanCollateral }}
            columnClassName={(_, { isDefaulted }) => `text-xs ${ isDefaulted ? 'red' : '' }`}
            columnTitle
            dataAlign="center"
            csvHeader="Collateral"
            width="150"
          >
            Collateral
          </TableHeaderColumn>

          <TableHeaderColumn
            ref={ this.setImeisListRef }
            dataField="imeisList"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            columnClassName={(_, { isDefaulted }) => isDefaulted ? 'red' : ''}
            columnTitle
            csvHeader="IMEIs"
            csvFieldType="string"
            width="150"
          >
            IMEIs
          </TableHeaderColumn>          

          <TableHeaderColumn
            ref={ this.setCreatedByNameRef }
            dataField="createdByName"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            columnClassName={(_, { isDefaulted }) => isDefaulted ? 'red' : ''}
            columnTitle
            csvHeader="Created By"
            width="150"
          >
            Create By
          </TableHeaderColumn>

          <TableHeaderColumn
            ref={ this.setAssignToNameRef }
            dataField="assignToName"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            columnClassName={(_, { isDefaulted }) => isDefaulted ? 'red' : ''}
            columnTitle
            csvHeader="Assign To"
            width="150"
          >
            Assign To
          </TableHeaderColumn>

          <TableHeaderColumn
            ref={ this.setStatusRef }
            dataField="status"
            dataSort
            dataAlign="center"
            dataFormat={(cell, { isDefaulted }) => isDefaulted
              ? <span className="red px-5 rounded-10 border-1 border-red" title="Defaulted loan">Defaulted</span>
              : <small style={{ color: statusColorStyle(cell) }}>{ cell }</small>
            }
            filter={{ type: "SelectFilter", options: getStatusesByUserRole(this.authenticated) }}
            csvHeader="Status"
            width="150"
          >
            Status
          </TableHeaderColumn>

          <TableHeaderColumn
            ref={ this.setDisburseDateFormattedRef }
            dataField="disburseDateFormatted"
            dataAlign="center"
            dataSort
            filter={{ type: "DateFilter", delay: 1000 }}
            columnClassName={(_, { isDefaulted }) => `text-xs ${ isDefaulted ? 'red' : ''}`}
            columnTitle
            csvHeader="Start date"
            width="150"
          >
            Start date
          </TableHeaderColumn>

          <TableHeaderColumn
            isKey
            dataField="id"
            dataAlign="center"
            dataFormat={(_, x) => this.renderActionButtons(x, devicesToOpen)}
            csvHeader="Loan ID"
            width="80"
          />
        </LoanTable>
      </div>
    )
  }
}

const mapStateToProps = state => {

  const originalPagedLoans = DckSelectors.selectAllItems(state, ItemTypes.Loan),

  devicesToOpen = DckSelectors.selectAllItems(state, ItemTypes.DevicesToOpen),

  pagedLoans = originalPagedLoans instanceof Array 
    ? getDefaultPagedResult()
    : originalPagedLoans

  return { pagedLoans, devicesToOpen }
},

mapDispatchToProps = dispatch => ({

  loadLoans: filteringOptions => dispatch(DckActionCreators.itemsLoad(ItemTypes.Loan, filteringOptions)),

  removeLoans: ids => dispatch(DckActionCreators.itemRemove(ItemTypes.Loan, ids)),

  setSelectedLoans: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.Loan, id)),

  setLoanStatus: (id, status) => dispatch(changeLoanStatus(id, status)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListLoans)



// WEBPACK FOOTER //
// ./src/components/Loans/List.js